import { OnInit, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError, retry, takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  // API url
  url = environment.api_url;
  baseApiUrl = this.url;

  
  constructor(private http: HttpClient) {}

  // Returns an observable
  public upload(file) {
      // Create form data
    const formData = new FormData();

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': "application/x-www-form-urlencoded"
      }),
    };



    // Store form name as "file" with file data
    formData.append('file', file, file.name);
    // Make http post request over api
    // with formData as req
    var a =  this.http.post(this.baseApiUrl + '/fileupload', formData).pipe(retry(1));
    return a;
  }


  public removefilefromupload(path)
  {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': "application/json"
      }),
    };


    var a =  this.http.post(this.baseApiUrl + '/removefilefromupload', path,httpOptions).pipe(retry(1));
    return a;
  }
}
